import { httpGet, httpPost } from '../../../utils/api.utils';
import {
    getCustomerCreditCardInfo,
    setCustomerCreditCardInfoError,
    setSuccessMessage,
    getVitualCard,
    resetVirtualCard
} from '../../../constants/model-reducers/common/stripe.settings';

const defaultState = () => ({
    customerId:null,
    paymentMethod: null,
    virtualCardInfo: null,
    hasError: false,
    errorMessage: ''
});

const initialState = defaultState();


export const stripeActions = {
    saveCreditCardInfo: (paymentMethod=null) => async (dispatch, state) =>{
        try {
            var data = {
                Name: paymentMethod?.billing_details?.name ?? null,
                PaymentMethodId: paymentMethod?.id ?? null,
                Email: paymentMethod?.billing_details?.email ?? null
            }            
            var result = await httpPost(`external/stripe/createcustomer`,data)
            if(result.ok) {              
                dispatch({
                    type: setSuccessMessage,
                    payload: result.customerId,
                    hasError: false,
                    errorMessage: ''
                });
                return result;
            } else {
                const errorMessage = await await result.json();
                 dispatch({
                    type: setCustomerCreditCardInfoError,
                    payload: errorMessage.error || 'An unknown API error occurred.',
                    hasError: true,
                });
                 return { ok: false, error: errorMessage.error };
            }           
        }catch(apiError) {
            dispatch({
                type: setCustomerCreditCardInfoError,
                payload: apiError,
                hasError: false,
            });
             return { ok: false, error: apiError.message };
        }
    },
    createVirtualCard:(userData=null)=> async (dispatch,state)=>{
        try {
            const data = {
                FirstName: userData.firstName,
                LastName: userData.lastName,
                Email: userData.email,
                BillingAddress: {
                    Line1: userData.billingaddress.address, 
                    City: userData.billingaddress.city,
                    State: userData.billingaddress.state,
                    PostalCode: userData.billingaddress.postalCode,
                    Country: userData.billingaddress.country,
                }
            };         
            var result = await httpPost(`external/stripe/createvirtualcard`,data)
            dispatch({
                type: setSuccessMessage,
                payload: result.customerId
            })
            return result;
        }catch(apiError) {
            dispatch({
                type: setCustomerCreditCardInfoError,
                payload: apiError
            })
        }
    },
    fetchPaymentInfo:(orderId=0)=> async (dispatch,state)=>{
        var result = await httpGet(`external/stripe/getPaymentMethod/${orderId}`)
       try {
         dispatch({
            type: getCustomerCreditCardInfo,
            payload: result[0]
        });
        return result   
       } catch(apiError) {
         dispatch({
            type: setCustomerCreditCardInfoError, 
            payload: apiError});
        return false
       }
    },
    fetchVirtualCardInfo:(orderId=0)=> async (dispatch,state)=>{
        var result = await httpGet(`external/stripe/getvirtualcard/${orderId}`)
       try {
         dispatch({
            type: getVitualCard,
            payload: result
        });
        return result   
       } catch(apiError) {
         dispatch({
            type: setCustomerCreditCardInfoError, 
            payload: apiError});
        return false
       }
    },
    fundGenerateVirtualCard:(orderId=0)=>async (dispatch,state) => {
        try {
             var result = await httpPost(`external/stripe/generatevirtualcard/${orderId}`)
            if(result && result.success) {
              
                return result;
            } else {
               return { success: false, 
                message: "Unable to generate virtual card"
            };
            }
        }catch(apiError) {
            return { success: false, 
                message: apiError.message 
            };
        }
    },
    resetCardData:()=>(dispatch,state)=>{
        dispatch({
            type: resetVirtualCard,
            payload:null
        })
    }
};

export const reducer=(state,action) => {
    state = state || initialState;
    switch(action.type){
        case setSuccessMessage:
            return {
                ...state,
                customerId: action.payload
            };
        case getCustomerCreditCardInfo:
            return {
                ...state,
                paymentMethod: action.payload,
                hasError: action.hasError
            };
        case setCustomerCreditCardInfoError: {
            return {
                ...state,
                hasError: action.hasError,
                errorMessage: action.payload
            }
        }
        case getVitualCard:
            return {
                ...state,
                virtualCardInfo: action.payload,
        }
        case resetVirtualCard:
            return {
                ...state,
                virtualCardInfo: action.payload,
                paymentMethod: action.payload
            }
        default:
            return state;
    }
}